import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import {Alert, Snackbar} from '@mui/material'
import { LoadingUI } from '../utils/LayoutStyles';
import API, { BaseURL } from '../api';


export const PaypalCheckout = ({ purchaseItems, paymentDone }) => {
  const [clientId, setClientId] = useState(null);

  const [openSnack, setOpenSnack] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  useEffect(() => {
    const fetchClientId = async () => {
      try {
        const response = await API.get('/paypalclientid');
        setClientId(response.data.clientId);
      } catch (error) {
        console.error('Error fetching PayPal client ID:', error);
      }
    };

    if (clientId === null) {
      fetchClientId();
    }
  }, [clientId]);

  // Paypal create order request
  const onCreateOrder = async () => {
    return fetch(`${BaseURL}/paypalcreateorder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        purchase_units: purchaseItems,
      }),
    })
      .then((response) => {

        if(response.status !== 200 && response.status !== 201){
          setErrorMessage(`Errore ${response.status}: contattare l'helpdesk all'indirizzo tesseramento@partitodemocratico.it`)
        }
        
        return response.json()
      })
      .then((order) => {
        return order.id;
      })
  };

  // Paypal checkout request
  const onApprovePaypal = async (data, actions) => {
    return fetch(`${BaseURL}/paypalcaptureorder/${data.orderID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {

        if(response.status !== 200 && response.status !== 201){
          setErrorMessage(`Errore ${response.status}: contattare l'helpdesk all'indirizzo tesseramento@partitodemocratico.it`)
        }

        return response.json();
      })
      .then((orderData) => {
        const { payer } = orderData;

        const paymentData = {
          id: orderData.id,
          name: payer.name.given_name,
          surname: payer.name.surname,
          email: payer.email_address,
          payer_id: payer.payer_id,
          status: orderData.status,
        };

        paymentDone(paymentData);
        return payer;
      })
  };

  // Paypal error management
  const onPaypalError = (data, actions) => {
    setOpenSnack(true)
  };

  if (!clientId) {
    return LoadingUI();
  }
  
  return (
    <>
    <PayPalScriptProvider
      options={{
        clientId,
        currency: 'EUR',
        intent: 'capture',
      }}
    >
      <PayPalButtons
        style={{ layout: 'vertical' }}
        createOrder={onCreateOrder}
        onApprove={onApprovePaypal}
        onError={onPaypalError}
      />
    </PayPalScriptProvider>

      <Snackbar
        anchorOrigin={{vertical:'bottom', horizontal:'center' }}
        open={openSnack}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
        onClose={handleClose}
        severity='error'
        variant='filled'
        sx={{width:'100%'}}>
          {errorMessage}
        </Alert>
      </Snackbar>



    </>

  );
};

// paypal checkout UI parameter type declaration
PaypalCheckout.propTypes = {
  purchaseItems: PropTypes.array,
  paymentDone: PropTypes.func,
};
